/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponse interface.
 */
export function instanceOfFxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponse(value) {
    if (!('ActivatedBranch' in value) || value['ActivatedBranch'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponseFromJSON(json) {
    return FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ActivatedBranch': json['ActivatedBranch'],
    };
}
export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponseToJSON(json) {
    return FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ActivatedBranch': value['ActivatedBranch'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesFtlIntegrationLauncherActivateKeyResponse.js.map